import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import {
	FreudButtonModule,
	FreudInputTextModule,
	FreudLoaderModule,
} from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';
import { AccordionModule } from 'shared/components/accordion/accordion.module';

import { VCHistoryCardModule } from '../vc-history-card/vc-history-card.module';
import { VCHistoryComponent } from './vc-history.component';

@NgModule({
	declarations: [VCHistoryComponent],
	imports: [
		CommonModule,
		FreudInputTextModule,
		TranslateModule,
		VCHistoryCardModule,
		FreudButtonModule,
		ReactiveFormsModule,
		FreudLoaderModule,
		AccordionModule,
	],
	exports: [VCHistoryComponent],
	providers: [],
})
export class VCHistoryModule {}
